import axios from 'axios'
import { DialogPlugin, MessagePlugin } from 'tdesign-vue-next';
import { getToken, toLoginPage } from "@/utils/auth";
import { getQueryParams } from './func'

const notMessage = ['/blade-logic/logic/run']

const notMessageHandler = (url) => {
    return notMessage.findIndex(item => url.includes(item)) >= 0 ? false : true
}

const httpUtil = axios.create({
    timeout: 1200000 // request timeout
})
httpUtil.interceptors.request.use(
    config => {
        const token = getToken();
        if (token) {
            config.headers['X-Token'] = token
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

httpUtil.interceptors.response.use(
    response => {
        const res = response.data
        console.log(response, 'response')
        if(location.href.includes('kfxt.jsyczls.com') && res.msg == 'ticket已过期') {
            return Promise.reject(new Error(res.msg || 'Error'))
        }
        if (res.code && res.code != 200) {
            if (res.code === 301) {//token失效
                const urlParams = getQueryParams()
                // 小程序单点登录 不需要这个提示
                if(urlParams.type == 'sso') {
                    return false
                }
                const confirmDia = DialogPlugin.confirm({
                    header: '确认退出',
                    body: '登录状态失效，请退出重新登录',
                    confirmBtn: '确定',
                    cancelBtn: '取消',
                    onConfirm: () => {
                        confirmDia.hide();
                        toLoginPage();
                    },
                    onClose: () => { confirmDia.hide(); },
                });
            } else if (res.code === 403) {//鉴权失败
                // MessagePlugin.error(res.msg)//发布时需要注释
            } else {
                console.log(notMessageHandler(response.config.url))
                notMessageHandler(response.config.url) && MessagePlugin.error(res.msg)//发布时需要注释
            }
            return Promise.reject(new Error(res.msg || 'Error'))
        } else {
            return res
        }
    }, error => {
        console.log('err', error)
        MessagePlugin.error(error.message)//发布时需要注释
        return Promise.reject(error)
    }
)
httpUtil.doRequest = function (url, method, params, headers) {
    return httpUtil({
        headers: headers,
        url: url,
        method: method,
        params
    })
}
httpUtil.doGet = function (url, params, headers) {
    return httpUtil({
        headers: headers,
        url: url,
        method: 'get',
        params
    })
}
httpUtil.doPost = function (headers, url, data) {
    return httpUtil({
        headers: headers,
        url: url,
        method: 'post',
        data: data
    })
}
export default httpUtil
